var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import MenuIcon from '../../assets/menu.svg';
import styles from './HomePage.module.scss';
import classNames from "classnames";
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { channelAPI, contactsAPI, messagesAPI } from "../../API/api";
import { closeBar, setLoadChat, setSearchMessages } from "../../store/slices/appSlice";
import { outChat, setChat } from "../../store/slices/setChatIDSlice";
import { clickType, RESERVED_CHANNEL_ID } from "../../constants/constants";
import { Badge } from "@mui/material";
import { createSelector } from "@reduxjs/toolkit";
import DialogComponent from "../Settings/DialogComponent";
import { createObjectChannel } from "../../utils/utils";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import AddContactForm from "../forms/AddContactForm";
import { EmptyList } from "../Settings/BlackList";
const ListItem = ({ user }) => {
    const channel = useAppSelector(state => state.app.selectedChannel);
    const add = () => __awaiter(void 0, void 0, void 0, function* () {
        yield messagesAPI.addChat(user, createObjectChannel(channel), channel.channelID);
        yield channelAPI.deleteApplication(channel.channelID, user);
    });
    const deleteRequest = () => {
        channelAPI.deleteApplication(channel.channelID, user);
    };
    return (_jsxs("li", { children: [_jsx("span", { children: user.displayName }), _jsxs("div", { style: { display: 'flex', gap: '6px' }, children: [_jsx("button", { onClick: add, style: { minWidth: '28px', fontWeight: 'bold' }, title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C", children: "+" }), _jsx("button", { onClick: deleteRequest, style: { minWidth: '28px', fontWeight: 'bold' }, title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", children: "--" })] })] }));
};
const ListRequests = ({ quantity }) => {
    return (_jsx("ul", { children: quantity.map(item => _jsx(ListItem, { user: item }, item.uid)) }));
};
const MembershipApplications = ({ quantity }) => {
    const [isOpen, setOpen] = useState(false);
    const openList = () => setOpen(true);
    const { t } = useTypedTranslation();
    return (_jsxs("li", { style: { display: 'flex', gap: '18px', alignItems: 'center' }, children: [_jsx("span", { onClick: openList, children: t('requests') }), _jsx("div", { children: _jsx(Badge, { badgeContent: quantity.length, color: "error" }) }), isOpen &&
                _jsx(DialogComponent, { isOpen: isOpen, onClose: setOpen, children: quantity.length > 0 ? _jsx(ListRequests, { quantity: quantity }) : _jsx(EmptyList, {}) })] }));
};
const selectApplyForMembership = createSelector([(state) => { var _a; return (_a = state.app.selectedChannel) === null || _a === void 0 ? void 0 : _a.applyForMembership; }], (applyForMembership) => applyForMembership !== null && applyForMembership !== void 0 ? applyForMembership : []);
const UserManagementMenu = ({ chatInfo }) => {
    var _a, _b;
    const [isOpen, setOpen] = useState(false);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const currentUser = useAppSelector(state => state.app.currentUser);
    const contactsList = useAppSelector(state => state.app.contacts);
    const blackList = useAppSelector(state => state.app.blackList);
    const myChatList = useAppSelector(state => state.app.chatsList);
    const selectedChat = useAppSelector(state => state.app.selectedChat);
    const isFavorites = useAppSelector(state => state.app.isFavorites);
    const quantity = useAppSelector(selectApplyForMembership);
    const { t } = useTypedTranslation();
    const isReservedChannel = RESERVED_CHANNEL_ID === ((_a = chatInfo === null || chatInfo === void 0 ? void 0 : chatInfo.channel) === null || _a === void 0 ? void 0 : _a.channelID);
    const dispatch = useAppDispatch();
    const [animationOpen, setAnimationOpen] = useState(false);
    const isOwner = currentUser.uid === ((_b = chatInfo === null || chatInfo === void 0 ? void 0 : chatInfo.channel) === null || _b === void 0 ? void 0 : _b.owner.uid);
    const addToContacts = (user) => __awaiter(void 0, void 0, void 0, function* () {
        contactsAPI.addToContacts(currentUser.email, user)
            .then(() => setIsOpenDialog(false))
            .then(() => setOpen(false));
    });
    const changeDialogState = () => {
        setIsOpenDialog((prev) => !prev);
        setOpen(false);
    };
    const deleteContact = () => {
        contactsAPI.removeFromContacts(currentUser.email, chatInfo)
            .then(() => setOpen(false));
    };
    const addToBlacklist = () => {
        contactsAPI.addToBlacklist(currentUser.email, chatInfo)
            .then(() => setOpen(false));
    };
    const removeFromBlacklist = () => {
        contactsAPI.removeFromBlacklist(currentUser.email, chatInfo)
            .then(() => setOpen(false));
    };
    const clearChat = () => {
        dispatch(setLoadChat(true));
        messagesAPI.clearChat(selectedChat, isFavorites)
            .then(() => setOpen(false))
            .catch(error => console.log(error))
            .finally(() => dispatch(setLoadChat(false)));
    };
    const deleteChat = () => {
        messagesAPI.deleteChat(currentUser, selectedChat)
            .then(() => {
            setOpen(false);
            dispatch(setChat(null));
        })
            .catch(error => console.log('ошибка удаления чата >>>>>', error));
    };
    const subscribe = () => {
        messagesAPI.addChat(currentUser, selectedChat)
            .then(() => setOpen(false))
            .catch((err) => console.log('Произошла ошибка подписки', err));
    };
    const unsubscribe = () => {
        messagesAPI.deleteChat(currentUser, selectedChat)
            .then(() => {
            setOpen(false);
            dispatch(outChat());
        })
            .catch((err) => console.log('Произошла ошибка отписки', err));
    };
    const showSearchMessages = () => {
        dispatch(setSearchMessages(true));
        setOpen(false);
    };
    const showInformation = () => {
        setOpen(false);
        dispatch(closeBar(clickType.SHOW_CHANNEL_INFO));
    };
    const isContact = useMemo(() => contactsList.some(item => item.email === chatInfo.email), [selectedChat, contactsList.length]);
    const isBlackList = useMemo(() => blackList.some(item => item.email === chatInfo.email), [blackList.length, selectedChat]);
    const isMyChat = useMemo(() => myChatList.some(item => { var _a; return item.uid === ((_a = chatInfo.channel) === null || _a === void 0 ? void 0 : _a.channelID); }), [myChatList.length, selectedChat]);
    const onKeyDown = (e) => {
        if (e.key === 'Enter')
            setOpen(!isOpen);
    };
    const setMenu = () => {
        setAnimationOpen(false);
        setOpen(!isOpen);
    };
    useEffect(() => {
        if (isOpen)
            setAnimationOpen(true);
        return () => setAnimationOpen(false);
    }, [isOpen]);
    const targetNode = () => {
        if (isFavorites)
            return (_jsxs("ul", { children: [_jsx("li", { onClick: showSearchMessages, children: t('search') }), _jsx("li", { onClick: clearChat, children: t('cleanHistory') })] }));
        else if (selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.channel)
            return (_jsxs("ul", { children: [_jsx("li", { onClick: showSearchMessages, children: t('search') }), !isReservedChannel &&
                        (isMyChat ?
                            !isOwner && _jsx("li", { onClick: unsubscribe, children: t('leaveTheChannel') })
                            :
                                _jsx("li", { onClick: subscribe, children: t('subscribe') })), _jsx("li", { onClick: showInformation, children: t('information') }), isOpen && isOwner && _jsx(MembershipApplications, { quantity: quantity })] }));
        else
            return (_jsxs("ul", { children: [_jsx("li", { onClick: showSearchMessages, children: t('search') }), isContact ?
                        _jsx("li", { onClick: deleteContact, children: t('removeFromContacts') })
                        :
                            _jsx("li", { onClick: changeDialogState, children: t('addToContacts') }), isBlackList ?
                        _jsx("li", { onClick: removeFromBlacklist, children: t('removeFromBlackList') })
                        :
                            _jsx("li", { onClick: addToBlacklist, children: t('addToBlackList') }), _jsx("li", { onClick: clearChat, children: t('cleanHistory') }), _jsx("li", { onClick: deleteChat, children: t('removeChat') })] }));
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classNames(styles.menu__cover, { [styles.menu_show]: isOpen }, { [styles.animationCover]: animationOpen }), onClick: setMenu }), _jsxs("div", { className: styles.menu__button, children: [_jsxs("div", { className: styles.menu__icon, children: [_jsx(MenuIcon, { cursor: 'pointer', fontSize: '1.3rem', onClick: () => setOpen(!isOpen), onKeyDown: onKeyDown, tabIndex: 8 }), Boolean(quantity.length) && isOwner && _jsx("div", { className: styles.menu__indicator })] }), _jsx("div", { className: classNames(styles.menu__list, { [styles.menu_show]: isOpen }, { [styles.animationMenu]: animationOpen }), children: targetNode() })] }), _jsx(DialogComponent, { onClose: changeDialogState, isOpen: isOpenDialog, children: _jsx(AddContactForm, { functionPerformed: addToContacts, user: chatInfo, add: true }) })] }));
};
export default UserManagementMenu;
